import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { Modal } from 'components/UI'
import { Header } from 'components/Modals/ScaleOptionModal/Create'
// view components
import PasswordChangeForm from './Form'
// themes
import { CloseIcon } from 'components/UI/Icons'
// constants
import { Modals } from 'constants/modals'

const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
}

const PasswordChangeModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.CHANGE_USER_PASSWORD_MODAL })

  return (
    <Modal width='xs' hideBackdrop isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS} disableBackdropClick>
      <Header>
        <span>Change Password</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <PasswordChangeForm hideModal={hideModal} />
    </Modal>
  )
}

export default PasswordChangeModal
